import React from 'react';

const BodyWrapper = ({ children }) => {
  return <div className="sponsors-wrapper">{children}</div>;
};
export default BodyWrapper;
